export const tableData = [
  {
    category: 'Equities',
    headers: [
      'Transaction date',
      'Symbol/ISIN',
      'Buy/Sell',
      'Quantity',
      'Price',
      'Commission',
      'Other Charges',
      'Fx Rate',
      'Settlement Account',
      'Custodian',
      'Note',
    ],
  },
  {
    category: 'Funds & ETFs',
    headers: [
      'Transaction date',
      'Symbol/ISIN',
      'Buy/Sell',
      'Quantity',
      'Price',
      'Commission',
      'Other Charges',
      'Fx Rate',
      'Settlement Account',
      'Custodian',
      'Note',
    ],
  },
  {
    category: 'Fixed Income',
    headers: [
      'Transaction date',
      'Settlement date',
      'Symbol/ISIN',
      'Buy/Sell',
      'Quantity',
      'Price',
      'Commission',
      'Other Charges',
      'Fx Rate',
      'Settlement Account',
      'Custodian',
      'Note',
    ],
  },
  {
    category: 'FX Spot Trades - Buy',
    headers: [
      'Instrument Type',
      'Transaction date',
      'Buy Currency',
      'Buy Quantity',
      'Sell Currency',
      'Sell Quantity',
      'Commission',
      'Other Charges',
      'Custodian',
      'Note',
    ],
  },
  {
    category: 'FX Spot Trades - Sell',
    headers: [
      'Instrument Type',
      'Transaction date',
      'Buy Currency',
      'Buy Quantity',
      'Sell Currency',
      'Sell Quantity',
      'Commission',
      'Other Charges',
      'Custodian',
      'Note',
    ],
  },
  {
    category: 'Deposits and Withdrawals',
    headers: [
      'Transaction date',
      'Deposit/Withdraw',
      'Quantity',
      'Currency',
      'Fx Rate',
      'Other Charges',
      'Custodian',
    ],
  },
  {
    category: 'Transfer',
    headers: [
      'Instrument Type',
      'Transaction date',
      'Currency',
      'Quantity',
      'Withdraw from Custodian',
      'Deposit to Custodian',
      'Other Charges',
      'Note',
    ],
  },
  {
    category: 'Cash Adjustments',
    headers: [
      'Transaction date',
      'Currency',
      'Fee Type',
      'Deduction/Rebate',
      'Quantity',
      'Fx Rate',
      'Custodian',
      'Settlement Account',
    ],
  },
];
